import Cookies from "js-cookie";
import { getTokenRemainingTime } from "./jwt";
let logoutTimer;

export const startSessionWatcher = (onExpire) => {
   const token = Cookies.get("access_token");
  if (!token) return;

  const remaining = getTokenRemainingTime(token);

  if (remaining <= 0) {
    onExpire();
    return;
  }

  logoutTimer = setTimeout(onExpire, remaining * 1000);
};

export const stopSessionWatcher = () => {
  if (logoutTimer) clearTimeout(logoutTimer);
};
